import { reactive, ref, computed } from "vue";
import { QUESTION_TYPE } from "@/services/survey/constants/QUESTION_TYPE";
import { sortQuestionsByListOrder } from "@/services/survey/methods/sortQuestionsByListOrder";
import { validateAnswers } from "@/services/survey/methods/validateAnswers";

/**
 * アンケート回答フォームの状態管理（回答値・バリデーション・チェックボックスの選択操作）
 */
export function useSurveyAnswers(questions) {
  const convertQuestionsToAnswerMap = (questions) => {
    return Object.fromEntries(
      questions.map((question) => [
        question.id,
        question.type === QUESTION_TYPE.CHECKBOX ? [] : "",
      ])
    );
  };

  const hasErrors = (errs) => Object.keys(errs).length > 0;

  const sortedQuestions = sortQuestionsByListOrder(questions);
  const answers = reactive(convertQuestionsToAnswerMap(sortedQuestions));
  const errors = ref({});

  const hasValidationError = computed(() => hasErrors(errors.value));

  const validate = () => {
    const newErrors = validateAnswers(sortedQuestions, answers);
    errors.value = newErrors;
    return !hasErrors(newErrors);
  };

  const removeCheckboxOption = (questionId, option) => {
    answers[questionId] = answers[questionId].filter(
      (answer) => answer !== option
    );
  };

  const addCheckboxOption = (questionId, option) => {
    answers[questionId] = [...answers[questionId], option];
  };

  const onChangeCheckbox = (questionId) => (option) => {
    const hasSelected = answers[questionId].includes(option);
    if (hasSelected) {
      removeCheckboxOption(questionId, option);
    } else {
      addCheckboxOption(questionId, option);
    }
  };

  const onChangeDefault = (questionId) => (value) => {
    answers[questionId] = value;
  };

  return {
    sortedQuestions,
    answers,
    errors,
    hasValidationError,
    validate,
    onChangeCheckbox,
    onChangeDefault,
  };
}
